import { useState } from 'react';
import { message } from 'antd';
import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { UPDATE_ORDER_NOTE, UpdateOrderNoteVariables, UpdateOrderNoteResponse } from '../pages/central/parcels/graphql/mutations/updateOrderNote';

interface UseUpdateOrderNoteParams {
    orderId: string;
    trackingNumber?: string | null;
    warehouseId?: string | null;
    refetch: () => Promise<any>;
}

interface UseUpdateOrderNoteResult {
    handleUpdateNote: (note: string) => Promise<void>;
    loading: boolean;
}

export const useUpdateOrderNote = ({
    orderId,
    trackingNumber,
    warehouseId,
    refetch
}: UseUpdateOrderNoteParams): UseUpdateOrderNoteResult => {
    const [updateOrderNote] = useMutation<UpdateOrderNoteResponse, UpdateOrderNoteVariables>(UPDATE_ORDER_NOTE);
    const [loading, setLoading] = useState(false);
    const { t } = useTranslation();

    const handleUpdateNote = async (note: string) => {
        if (!orderId) {
            message.error(t('central.parcels.messages.orderIdCannotBeEmpty'));
            return;
        }

        try {
            setLoading(true);
            await updateOrderNote({
                variables: {
                    input: {
                        orderId: orderId,
                        trackingNumber: trackingNumber || null,
                        note: note,
                        warehouseId: warehouseId,
                        noteType: 'CS_CUSTOMER_NOTE'
                    }
                }
            });
            // 重新加载订单详情数据
            await refetch();
        } catch (error) {
            console.error('更新备注失败:', error);
            throw error;
        } finally {
            setLoading(false);
        }
    };

    return {
        handleUpdateNote,
        loading
    };
};

